var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84013 6.45463C2.0511 6.24372 2.33719 6.12524 2.6355 6.12524C2.93381 6.12524 3.21991 6.24372 3.43088 6.45463L8.99963 12.0234L14.5684 6.45463C14.7806 6.2497 15.0647 6.13631 15.3597 6.13887C15.6547 6.14143 15.9368 6.25975 16.1454 6.46833C16.354 6.67692 16.4723 6.95908 16.4749 7.25405C16.4774 7.54902 16.3641 7.8332 16.1591 8.04538L9.795 14.4095C9.58403 14.6204 9.29794 14.7389 8.99963 14.7389C8.70132 14.7389 8.41522 14.6204 8.20425 14.4095L1.84013 8.04538C1.62922 7.83441 1.51074 7.54831 1.51074 7.25C1.51074 6.95169 1.62922 6.6656 1.84013 6.45463Z",
    fill: "#3040D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.f84b6f273e981c0f25b4ed0d3c935425.svg";
export { ForwardRef as ReactComponent };